import "../../dashboard/DashboardLayout.css";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Box, LoadingOverlay } from "@mantine/core";
import { BasicInformation } from "./informationTiles/basicInformation";
import { AddressInformation } from "./informationTiles/addressInformation";
import { OtherInformation } from "./informationTiles/otherInformation";
import {
  ApprovalStatus,
  createAccountFormValidation,
  createAccountInput,
  extendedAttributesType,
  popupType,
} from "../../../types/types";
import { CreateAccountValidator } from "./createAccountValidator";
import { GenericPopUp } from "../../popup/genericPopUp";
import { useAuth } from "../../../providers/AuthProvider";
import {
  uploadDocument,
  submitUserAccount,
  encryptData,
  getUserAccount,
  updateUserAccount,
  getUserAccountPayload,
  getEntityApproval,
  userApproval,
} from "../../../services/bankingService";
import "./createAccount.css";
import { getMetaData } from "../../../services/uiConfigService";

export function CreateAccount() {
  const loginid = JSON.parse(localStorage.authContext).user.loginId;

  const initialValues: createAccountInput = {
    nameOfAccountHolder: "",
    bankName: "",
    bankAccountNumber: "",
    confirmBankAccountNumber: "",
    pinCode: "",
    ifsc: "",
    addressLine1: "",
    addressLine2: "",
    email: "",
    mobile: "",
    constitution: "",
    contactName: "",
    authPersonName: "",
    pan: "",
    gstin: "",
    checkLeafURL: "",
    authorizationLetter: "",
  };

  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] =
    useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<Blob>();
  const [letterUploaded, setLetterUploaded] = useState<Blob>();
  const [successfullySubmitted, setSuccessfullySubmitted] = useState(false);
  const [inputs, setInputs] = useState(initialValues);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedFileLetter, setSelectedFileLetter] = useState("");
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");
  const [adminApproval, setAdminApproval] = useState<ApprovalStatus>(
    ApprovalStatus.INITIATE
  );
  const [disableInputs, setDisableInputs] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("");
  const [comment, setComment] = useState("");
  const [blobKey, setBlobKey] = useState("");
  const [extendedAttributes, setExtendedAttributes] = useState<extendedAttributesType>({
    bankName: "",
    ifsc: "",
    addressLine1: "",
    addressLine2: "",
    email: "",
    mobile: "",
    constitution: "",
    contactName: "",
    authPersonName: "",
    pan: "",
    gstin: "",
    checkLeafURL: "",
    authorizationLetter: "",
    pincode: "",
    accountNumber: "",
    accountHolderName: "",
  });
  const [blobKeyLetter, setBlobKeyLetter] = useState("");
  const [trigger, setTrigger] = useState<boolean>(false);
  const [formValidation, setFormValidation] =
    useState<createAccountFormValidation>({
      nameOfAccountHolder: {
        isValidated: true,
        message: "",
      },
      bankName: {
        isValidated: true,
        message: "",
      },
      bankAccountNumber: {
        isValidated: true,
        message: "",
      },
      confirmBankAccountNumber: {
        isValidated: true,
        message: "",
      },
      ifsc: {
        isValidated: true,
        message: "",
      },
      pinCode: {
        isValidated: true,
        message: "",
      },
      addressLine1: {
        isValidated: true,
        message: "",
      },
      addressLine2: {
        isValidated: true,
        message: "",
      },
      email: {
        isValidated: true,
        message: "",
      },
      mobile: {
        isValidated: true,
        message: "",
      },
      constitution: {
        isValidated: true,
        message: "",
      },
      contactName: {
        isValidated: true,
        message: "",
      },
      authPersonName: {
        isValidated: true,
        message: "",
      },
      pan: {
        isValidated: true,
        message: "",
      },
      gstin: {
        isValidated: true,
        message: "",
      },
      checkLeafURL: {
        isValidated: true,
        message: "",
      },
      authorizationLetter: {
        isValidated: true,
        message: "",
      },
    });
  const [declaration, setDeclaration] = useState<{
    text: string;
    accepted: boolean;
  }>({ text: "", accepted: false });
  const [declarationTextLoading, setDeclarationTextLoading] =
    useState<boolean>(false);

  const getUserAccountDetails = useCallback(async () => {
    const userAccount = await getUserAccount(loginid);
    return userAccount;
  }, [loginid]);

  const [blobKeyCheque,setBlobKeyCheque] = useState<string>("");
  const [blobKeyAuth,setBlobKeyAuth] = useState<string>("");

  useEffect(() => {
    const method = async () => {
      let userAccountDetails = await getUserAccountDetails();
      if (userAccountDetails.features.length !== 0) {
        setSuccessfullySubmitted(true);
      }
      let approvalStatus = await getEntityApproval(loginid);
      if (approvalStatus.features.length > 0) {
        const status = approvalStatus.features[0].status;
        if (status === "APPROVED" || status === "PENDING") {
          setExtendedAttributes(approvalStatus.features[0].extendedAttributes);
          setAdminApproval(
            status === "APPROVED"
              ? ApprovalStatus.APPROVED
              : ApprovalStatus.PENDING
          );
          setBlobKey(
            approvalStatus.features[0].extendedAttributes.blobCheckLeafURL
          );
          setBlobKeyLetter(
            approvalStatus.features[0].extendedAttributes
              .blobAuthorizationLetter
          );
          setSelectedFile(
            approvalStatus.features[0].extendedAttributes.checkLeafURL
          );
          setSelectedFileLetter(
            approvalStatus.features[0].extendedAttributes.authorizationLetter
          );
          setBlobKeyCheque(approvalStatus.features[0].extendedAttributes.checkLeafURL);

          setBlobKeyAuth(approvalStatus.features[0].extendedAttributes.authorizationLetter);
          setDisableInputs(true);
        }
        if (status === "REJECTED") {
          setComment(
            approvalStatus.features[0].extendedAttributes.rejectionComment
          );
          setDisableInputs(false);
          setAdminApproval(ApprovalStatus.REJECTED);
        }
      }
      const status = window.sessionStorage.getItem("status");
      const fetchFilledInputs = window.sessionStorage.getItem("filledInputs");
      if (fetchFilledInputs && status && status === "INPROGRESS") {
        let filledInputs = JSON.parse(fetchFilledInputs);
        if (filledInputs["checkLeafURL"]) {
          filledInputs["checkLeafURL"] = "";
        }
        if (filledInputs["authorizationLetter"]) {
          filledInputs["authorizationLetter"] = "";
        }
        setInputs(filledInputs);
      }
    };
    const getDeclarationData = async () => {
      try {
        setDeclarationTextLoading(true);

        const response = await getMetaData("clientconfig", "WD_configuration");
        if (response) {
          const declarationText = response.find(
            (item: any) => item.name === "declarationText"
          );
          setDeclaration((pre) => ({
            ...pre,
            text: declarationText.value ?? "",
          }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setDeclarationTextLoading(false);
      }
    };

    method();
    getDeclarationData();
  }, [trigger]);

  useEffect(() => {
    if (extendedAttributes != null) {
        setInputs((prevState) => ({
            ...prevState,
            ...extendedAttributes,
            nameOfAccountHolder: extendedAttributes?.accountHolderName,
            pinCode: extendedAttributes?.pincode,
            bankAccountNumber: extendedAttributes?.accountNumber,
            confirmBankAccountNumber: extendedAttributes?.accountNumber,
        }));
    }
}, [extendedAttributes]);

  const testClick = async () => {
    setDisableInputs(false);
    setLoaderShowOnCreateAccount(true);
    const updateCreateAccount = await getUserAccountPayload(loginid);
    window.sessionStorage.setItem("status", "INPROGRESS");
    inputs.addressLine1 =
      updateCreateAccount[0].accountInfoDetails.addressLine1;
    inputs.addressLine2 =
      updateCreateAccount[0].accountInfoDetails.addressLine2;
    inputs.email = updateCreateAccount[0].accountInfoDetails.email;
    inputs.constitution =
      updateCreateAccount[0].accountInfoDetails.constitution;
    inputs.contactName = updateCreateAccount[0].accountInfoDetails.contactName;
    inputs.authPersonName =
      updateCreateAccount[0].accountInfoDetails.authPersonName;

    setInputs(inputs);
    setAdminApproval(ApprovalStatus.INITIATE);
    setLoaderShowOnCreateAccount(false);
  };

  const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    const updatedInputs = { ...inputs, [name]: value };
    setInputs(updatedInputs);
    window.sessionStorage.setItem(
      "filledInputs",
      JSON.stringify(updatedInputs)
    );
    if (!window.sessionStorage.getItem("status")) {
      window.sessionStorage.setItem("status", "INPROGRESS");
    }
  };
  
  const submitForm = async () => {
    if (!declaration.accepted) return;
    var blobKeyChequeVar = "";
    var blobKeyAuthVar = "";
    setLoaderShowOnCreateAccount(true);
    if (validate()) {
      // if (blobKey == "" && blobKeyLetter == "") {
      //   const formData = new FormData();
      //   fileUploaded && formData.append("files", fileUploaded, selectedFile);
      //   const fileUploadResponse = await uploadDocument(formData);
      //   blobKeyChequeVar = JSON.parse(fileUploadResponse[0].body).features[0].Uri ;
      //   setBlobKeyCheque(blobKeyChequeVar);
      //   setBlobKey(blobKeyChequeVar);
      //   const formData1 = new FormData();
      //   letterUploaded &&
      //     formData1.append("files", letterUploaded, selectedFileLetter);
      //   const letterUploadResponse = await uploadDocument(formData1);
      //   blobKeyAuthVar =JSON.parse(letterUploadResponse[0].body).features[0].Uri ;
      //   setBlobKeyAuth(blobKeyAuthVar)
      //   setBlobKeyLetter(blobKeyAuthVar);
      //   setInputs((inputs) => ({
      //     ...inputs,
      //     checkLeafURL: blobKeyCheque,
      //     authorizationLetter: blobKeyAuth,
      //   }));
      // }
      if (blobKey === "" || blobKeyLetter === "") {
        if (blobKey === "") {
          const formData = new FormData();
          if (fileUploaded) {
            formData.append("files", fileUploaded, selectedFile);
          }

          const fileUploadResponse = fileUploaded ? await uploadDocument(formData) : null;

          if (fileUploadResponse && fileUploadResponse[0]?.body) {
            try {
              blobKeyChequeVar = JSON.parse(fileUploadResponse[0].body)?.features?.[0]?.Uri || "";
              setBlobKeyCheque(blobKeyChequeVar);
              setBlobKey(blobKeyChequeVar);
            } catch (err) {
              console.error("Cheque JSON parse error:", err);
            }
          }
        }

        if (blobKeyLetter === "") {
          const formData1 = new FormData();
          if (letterUploaded) {
            formData1.append("files", letterUploaded, selectedFileLetter);
          }
          const letterUploadResponse = letterUploaded ? await uploadDocument(formData1) : null;
          if (letterUploadResponse && letterUploadResponse[0]?.body) {
            try {
              blobKeyAuthVar = JSON.parse(letterUploadResponse[0].body)?.features?.[0]?.Uri || "";
              setBlobKeyAuth(blobKeyAuthVar);
              setBlobKeyLetter(blobKeyAuthVar);
            } catch (err) {
              console.error("Auth JSON parse error:", err);
            }
          }
        }
        setInputs((inputs) => ({
          ...inputs,
          checkLeafURL: blobKeyCheque,
          authorizationLetter: blobKeyAuth,
        }));
      }
      const extraAttributes = {
        pincode: inputs.pinCode,
        authorizationLetter: inputs.authorizationLetter,
        blobCheckLeafURL: blobKeyChequeVar ?? blobKey,
        blobAuthorizationLetter: blobKeyAuthVar ?? blobKeyLetter,
      };
      const accountInfo = {
        loginId: loginid,
        accountNumber: await encryptData(inputs.bankAccountNumber),
        ifsc: await encryptData(inputs.ifsc),
        accountHolderName: await encryptData(inputs.nameOfAccountHolder),
        authPersonName: await encryptData(inputs.authPersonName),
        email: await encryptData(inputs.email),
        mobile: await encryptData(inputs.mobile),
        contactName: await encryptData(inputs.contactName),
        pan: await encryptData(inputs.pan),
        gstin: await encryptData(inputs.gstin),
        checkLeafURL: await encryptData(inputs.checkLeafURL),
        addressLine1: await encryptData(inputs.addressLine1),
        addressLine2: await encryptData(inputs.addressLine2),
        constitution: await encryptData(inputs.constitution),
        bankName: await encryptData(inputs.bankName),
        extendedAttributes: extraAttributes,
      };

      const encryptedBody = {
        loginId: loginid,
        accountInfo: accountInfo,
      };

      const requestBodyForAdminApproval = {
        loginId: loginid,
        status: "PENDING",
        accountInfo: accountInfo,
      };
      if (adminApproval !== ApprovalStatus.APPROVED) {
        let response;

        try {
          response = await userApproval(requestBodyForAdminApproval);
        } catch (e: any) {
          setLoaderShowOnCreateAccount(false);
          openPopup(e?.response?.data?.message, "Error");
        }
        if (response?.feature?.status === "APPROVED") {
          setAdminApproval(ApprovalStatus.APPROVED);
        }
        if (response?.status === "Success") {
          setAdminApproval(ApprovalStatus.PENDING);
          setDisableInputs(true);
        }
      } else {
        let submitDetailsResponse;

        try {
          // let userAccountDetails = await getUserAccount(encryptedBody.loginId);
          // if (userAccountDetails.features.length > 0) {
          //   submitDetailsResponse = await updateUserAccount(encryptedBody);
          // } else {
            submitDetailsResponse = await submitUserAccount(encryptedBody);
          //}
          if (submitDetailsResponse.status === "Success") {
            window.sessionStorage.setItem("status", "SUCCESS");
            setLoaderShowOnCreateAccount(false);
            openPopup("Account has been successfully validated", "Success");
            setInputs(initialValues);
            window.sessionStorage.removeItem("filledInputs");
            setSelectedFile("");
            setSelectedFileLetter("");
            setFileUploaded(undefined);
            setLetterUploaded(undefined);
            setBlobKey("");
            setBlobKeyLetter("");
            hiddenFileInput.current.value = "";
            hiddenLetterInput.current.value = "";
            setInputs((inputs) => ({
              ...inputs,
              checkLeafURL: "",
              authorisationLetter: "",
            }));
            setSuccessfullySubmitted(true);
            setTrigger(!trigger);
          } else {
            setLoaderShowOnCreateAccount(false);
            openPopup(submitDetailsResponse.message, "Error");
            setDisableInputs(false);
            setAdminApproval(ApprovalStatus.REJECTED);
            window.sessionStorage.clear();
          }
        } catch (e: any) {
          setLoaderShowOnCreateAccount(false);
          openPopup(e?.response?.data?.message, "Error");
          setDisableInputs(false);
          setAdminApproval(ApprovalStatus.REJECTED);
        }
      }
      setLoaderShowOnCreateAccount(false);
    } else {
      setLoaderShowOnCreateAccount(false);
    }
  };
  const validate = () => {
    return new CreateAccountValidator().validateAccountInfo(inputs, {
      setFormValidation,
      formValidation,
      openPopup,
    });
  };

  const hiddenFileInput = useRef() as React.MutableRefObject<HTMLInputElement>;
  const hiddenLetterInput =
    useRef() as React.MutableRefObject<HTMLInputElement>;

  const handleFileClick = (event: any) => {
    hiddenFileInput.current && hiddenFileInput.current.click();
  };

  const handleLetterClick = (event: any) => {
    hiddenLetterInput.current && hiddenLetterInput.current.click();
  };

  const handleChangeDropDown = (selected: string, name: string) => {
    const updatedInputs = { ...inputs, [name]: selected };
    setInputs(updatedInputs);
    window.sessionStorage.setItem(
      "filledInputs",
      JSON.stringify(updatedInputs)
    );
    setFormValidation({
      ...formValidation,
      constitution: { message: "", isValidated: true },
    });
  };

  const handleChangeDropDownBankName = (selected: string, name: string) => {
    const updatedInputs = { ...inputs, [name]: selected };
    setInputs(updatedInputs);
    window.sessionStorage.setItem(
      "filledInputs",
      JSON.stringify(updatedInputs)
    );
    setFormValidation({
      ...formValidation,
      bankName: { message: "", isValidated: true },
    });
  };

  const handleFileChange = (event: any) => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      let fileName = fileUploaded.name;
      if (fileUploaded.type !== "application/pdf") {
        openPopup("Please upload a pdf file", "Alert");
        setSelectedFile("");
        setFileUploaded(undefined);
        hiddenFileInput.current.value = "";
        fileName = "";
      } else if (fileUploaded.size > 5242880) {
        openPopup("Uploaded file is very large in size", "Alert");
        setSelectedFile("");
        setFileUploaded(undefined);
        hiddenFileInput.current.value = "";
        fileName = "";
      }
      if (fileName) {
        setFileUploaded(fileUploaded);
      }
      setSelectedFile(fileName);

      const updatedInputs = { ...inputs, checkLeafURL: fileName };
      setInputs(updatedInputs);
      setFormValidation({
        ...formValidation,
        checkLeafURL: { message: "", isValidated: true },
      });
    }
  };

  const handleLetterChange = (event: any) => {
    const letterUploaded = event.target.files[0];
    if (letterUploaded) {
      let fileName = letterUploaded.name;
      if (letterUploaded.type !== "application/pdf") {
        openPopup("Please upload a pdf file", "Alert");
        setSelectedFileLetter("");
        setLetterUploaded(undefined);
        hiddenLetterInput.current.value = "";
        fileName = "";
      } else if (letterUploaded.size > 5242880) {
        openPopup("Uploaded file is very large in size", "Alert");
        setSelectedFileLetter("");
        setLetterUploaded(undefined);
        hiddenLetterInput.current.value = "";
        fileName = "";
      }
      if (fileName) {
        setLetterUploaded(letterUploaded);
      }
      setSelectedFileLetter(fileName);

      const updatedInputs = { ...inputs, authorizationLetter: fileName };
      setInputs(updatedInputs);
      setFormValidation({
        ...formValidation,
        authorizationLetter: { message: "", isValidated: true },
      });
    }
  };

  window.addEventListener(
    "message",
    (event) => {
      if (!event.origin.includes("sellina")) return;
      window.sessionStorage.clear();
    },
    false
  );
  return (
    <div className="app-container">
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}

      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />

      <Box
        sx={(theme) => ({
          backgroundColor: theme.colors.gray[3],
          padding: "10px",
          width: "100%",
          height: "100%",
        })}
      >
        <BasicInformation
          handleChange={handleChange}
          formValidation={formValidation}
          inputs={inputs}
          setFormValidation={setFormValidation}
          submitForm={submitForm}
          handleChangeDropDownBankName={handleChangeDropDownBankName}
          successfullySubmitted={successfullySubmitted}
          testClick={testClick}
          loginid={loginid}
          disableInputs={disableInputs}
          adminApproval={adminApproval}
        />

        <AddressInformation
          handleChange={handleChange}
          formValidation={formValidation}
          inputs={inputs}
          setFormValidation={setFormValidation}
          submitForm={submitForm}
        />

        <OtherInformation
          handleChange={handleChange}
          formValidation={formValidation}
          inputs={inputs}
          setFormValidation={setFormValidation}
          hiddenFileInput={hiddenFileInput}
          hiddenLetterInput={hiddenLetterInput}
          handleFileClick={handleFileClick}
          handleLetterClick={handleLetterClick}
          submitForm={submitForm}
          selectedFile={selectedFile}
          handleFileChange={handleFileChange}
          handleLetterChange={handleLetterChange}
          dropDownValue={dropDownValue}
          setDropDownValue={setDropDownValue}
          handleChangeDropDown={handleChangeDropDown}
          declaration={declaration}
          setDeclaration={setDeclaration}
          declarationTextLoading={declarationTextLoading}
          selectedFileLetter={selectedFileLetter}
          adminApproval={adminApproval}
          fileUploaded={fileUploaded}
          letterUploaded={letterUploaded}
          comment={comment}
          disableInputs={disableInputs}
          blobKey={blobKey}
          blobKeyLetter={blobKeyLetter}
        />
      </Box>
    </div>
  );
}
